const handleCallback = (res) => {
    console.log('收到了来自原生层的数据:', res);
    // 根据实际需求处理数据
  };
export const anbCallNative = (method, params, time = 5000) => {
  return new Promise((resolve, reject) => {
    if (params && params.callBack) {
      let _timeout = setTimeout(() => {
        console.log(`调用 ${method} timeout`);
        clearTimeout(_timeout);
        resolve({
          code: 0,
          message: `Call ${method} timeout`,
        });
      }, time);
      window[params.callBack] = function (res) {
        clearTimeout(_timeout);
        _timeout = null;
        console.warn(`调用 ${method} callBack`);
        console.warn(res);
        resolve(res);
      };
    }
    const cmdStr = `${method}?params=${encodeURIComponent(
      JSON.stringify(params || {})
    )}`;

    if (window.AGApp) {
      window.AGApp.CallNative(cmdStr);
    } else if (window.webkit.messageHandlers.AGApp) {
      const content = window.webkit;
      content.messageHandlers.AGApp.postMessage(cmdStr);
    } else {
      throw new Error("env not support call native");
    }
  });
};
//获取高度
export const getStatusBarRectCb = () => {
    let params = {
        callBack:'handleCallback'
    };
    return new Promise((resolve, reject) => {
        try {
            const result = anbCallNative("AGRoute://MTUIRoute/getStatusBarRect", params);
            resolve(result);
        } catch (error) {
            reject(error);
        }
    });
};

export const shareAnbWX = ({title, descMsg, thumbImageUrl, thumbImage64Str, linkString}) => {
  let params = {
    shareType: 2,
    shareToWhere: [4], // shareToWhere: [4]好友 shareToWhere: [3]朋友圈
    title,
    descMsg,
    thumbImageUrl,
    thumbImage64Str,
    linkString,
    callBack: (res) => {
      console.log("======> ", res);
    },
  };
  anbCallNative("AGRoute://MTShareRoute/directShareTo", params);
};
export const shareAnbPYQ = ({title, descMsg, thumbImageUrl, thumbImage64Str, linkString}) => {
    let params = {
      shareType: 2,
      shareToWhere: [3], // shareToWhere: [4]好友 shareToWhere: [3]朋友圈
      title,
      descMsg,
      thumbImageUrl,
      thumbImage64Str,
      linkString,
      callBack: (res) => {
        console.log("======> ", res);
      },
    };
    anbCallNative("AGRoute://MTShareRoute/directShareTo", params);
  };
//是否是爱农宝app
export const isAnb = () => {
  const userAgent = navigator.userAgent;
  return /anbios|anbandroid/i.test(userAgent);
};
export const isAnbIos = () => {
    const userAgent = navigator.userAgent;
    return /anbios/i.test(userAgent);
  };
//返回首页
export const backLink = () => {
  let params = {};
  anbCallNative("AGRoute://MTUIRoute/popSelfVC", params);
};
//保存本地图片
export const savImg = ({ imageBase64 }) => {
  let params = {
    imageBase64,
  };
  anbCallNative("AGRoute://MTCommonRoute/savePhotoToSDCard", params);
};



// WEBPACK FOOTER //
// ./src/environment/anb_api.js